import React, { useContext, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { AgendaContext } from '../context/AgendaContext';
import ActionForm from './forms/ActionForm';
import DocActionMenu from './DocActionMenu';
import ToggleForm from './ToggleForm';
import { DocsWrapper, TableColumn } from '../styles/TableStyle';
import { useTranslation } from 'react-i18next';

const ClcAction = () => {
    const { t } = useTranslation(); 
    const { clcActionDocs, setClcActionDocs } = useContext(AgendaContext);

    const dynamicFields = [
        { type: 'text', label: t('common.formLabels.reference.name'), name: 'reference', placeholder: t('common.formLabels.reference.label'), required: true },
        { type: 'textarea', label: t('common.formLabels.title.name'), name: 'title', placeholder: t('common.formLabels.title.label'), required: true },
    ]

    const [editItem, setEditItem] = useState({
        id: null,
        reference: '',
        title: '',
        deadline: '',
        document_links: [
            { fileName: '', url: '' },
            { fileName: '', url: '' }
        ],
        action: '',
        custom_action: ''
    });

    const [newTask, setNewTask] = useState({
        id: null,
        reference: '',
        deadline: '',
        title: '',
        document_links: [
            { fileName: '', url: '' },
            { fileName: '', url: '' }
        ],
        action: '',
        custom_action: ''
    });

    useEffect(() => {
        localStorage.setItem('clc_action_docs', JSON.stringify(clcActionDocs));
    }, [clcActionDocs]);

    const handleEditCancel = () => {
        setEditItem(prev => ({
            ...prev, 
            id: null
        }))
    }; 

    const handleNewTaskChange = (event) => {
        const { name, value } = event.target;

        if (name.startsWith('document_links')) {
            const index = parseInt(name.split('.')[1], 10);
            const updatedLinks = [...newTask.document_links];
            const property = name.split('.')[2]; // This will either be 'fileName' or 'url'
            updatedLinks[index] = { ...updatedLinks[index], [property]: value };
            setNewTask({ ...newTask, document_links: updatedLinks });

        } else if (name === 'action' && value !== t('actionDocs.tableHeadTitles.optionList.customAction')) {
            setNewTask({
                ...newTask,
                action: value,
                custom_action: '',
            });
        } else {
            setNewTask({ ...newTask, [name]: value });
        }
    };

    const handleEditTaskChange = (event) => {
        const { name, value } = event.target;

        if (name.startsWith('document_links')) {
            const index = parseInt(name.split('.')[1], 10);
            const updatedLinks = [...editItem.document_links];
            const property = name.split('.')[2]; // This will either be 'fileName' or 'url'
            updatedLinks[index] = { ...updatedLinks[index], [property]: value };
            setEditItem({ ...editItem, document_links: updatedLinks });
        } else if (name === 'action' && value !== t('actionDocs.tableHeadTitles.optionList.customAction')) {
            setEditItem({
                ...editItem,
                action: value,
                custom_action: '',
            });
        } else {
            setEditItem({ ...editItem, [name]: value });
        }
    };

    const handleSubmitNewTask = (event) => {
        event.preventDefault();
        const { reference, title, deadline, document_links, action, custom_action } = newTask;

        setClcActionDocs((prevItems) => [
            ...prevItems,
            {
                id: uuidv4(),
                reference: reference,
                title: title,
                deadline: deadline,
                document_links: document_links,
                action: action,
                custom_action: custom_action
            },
        ]);
        setNewTask({ id: null, reference: '', title: '', deadline: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }], action: '', custom_action: '' })
    };

    const handleSubmitEditTask = (event) => {
        event.preventDefault();
        const { reference, title, deadline, document_links, action, custom_action } = editItem;

        setClcActionDocs((prevItems) =>
            prevItems.map((item) =>
                item.id === editItem.id
                    ? { ...item, reference, title, deadline, document_links, action, custom_action }
                    : item
            )
        )

        setEditItem({ id: null, reference: '', title: '', deadline: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }], action: '', custom_action: '' });
    }

    const handleEditTextClick = (item) => {
        setEditItem({
            id: item.id,
            reference: item.reference,
            title: item.title,
            deadline: item.deadline,
            document_links: item.document_links,
            action: item.action,
            custom_action: item.custom_action
        })
    }

    const handleDeleteText = (id) => {
        const deleteItems = clcActionDocs.filter((item) => item.id !== id)
        setClcActionDocs(deleteItems)
        localStorage.setItem('clc_action_docs', JSON.stringify(deleteItems))
    }

    return (
        <div>
            <div>
                {clcActionDocs && clcActionDocs.length > 0 ? (
                    <DocsWrapper type='action_documents'>
                        <div>
                            <span>{t('common.formLabels.reference.name')}</span>
                            <span>{t('actionDocs.tableHeadTitles.deadline.name')}</span>
                            <span>{t('actionDocs.tableHeadTitles.action.name')}</span>
                            <span></span>
                        </div>
                        {clcActionDocs.map((item, index) => (
                            <div key={item.id}>
                                {editItem.id === item.id ? (
                                    <ActionForm
                                        item={editItem}
                                        setItem={setEditItem}
                                        handleOnChange={handleEditTaskChange}
                                        handleSubmit={handleSubmitEditTask}
                                        handleEditCancel={handleEditCancel}
                                        title={`${t('common.edit')} ${t('actionDocs.clcDocument')} #${index + 1}`}
                                        type='edit_task'
                                        dynamicFields={dynamicFields}
                                        buttonColorTheme='lightBlue'
                                    />

                                ) : (
                                    <>
                                        <TableColumn>
                                            <p>{item.reference}</p>
                                            <div>
                                                {item.document_links && item.document_links.map((link, linkIndex) => (
                                                    <a key={linkIndex} href={link.url} target='_blank' rel='noopener noreferrer'>{link.fileName}</a>
                                                ))}
                                            </div>
                                            <p>{item.title}</p>
                                        </TableColumn>
                                        <span>{new Date(item?.deadline).toLocaleDateString()}</span>
                                        <span>{item.custom_action !== '' ? item.custom_action : item.action}</span>
                                        <span>
                                            <DocActionMenu 
                                                item={item}
                                                handleDeleteText={handleDeleteText}
                                                handleEditTextClick={handleEditTextClick}
                                            />
                                        </span>
                                    </>
                                )}
                            </div>
                        ))}
                    </DocsWrapper>
                ) : (
                    <span>{t('common.noDocuments')}</span>
                )}
            </div>
            <ToggleForm style={{ padding: '1rem 0 0 0' }}>
                <ActionForm
                    item={newTask}
                    setItem={setNewTask}
                    handleOnChange={handleNewTaskChange}
                    handleSubmit={handleSubmitNewTask}
                    title={`${t('common.addBtnLabel')} ${t('actionDocs.clcDocument')}`}
                    type='new_task'
                    dynamicFields={dynamicFields}
                    buttonColorTheme='darkBlue'
                />
            </ToggleForm>
        </div>
    );
};

export default ClcAction